module.exports = __webpack_public_path__ + "static/media/hand-holding-heart.2f0e3323.svg";